<template>
  <div>
    <a-tabs
      v-model:activeKey="activeKey"
      :animated="false"
      @change="
        (e) => {
          changePage(1, e);
        }
      "
    >
      <a-tab-pane key="07" :tab="'文章（' + page.allSize + '）'">
        <div class="list" v-if="list.length > 0">
          <div class="item" v-for="item in list" :key="item.essay_id">
            <div class="title">
              <router-link
                :to="{ path: '/view/detail', query: { id: item.res_id } }"
                target="_blank"
                >{{ item.title }}</router-link
              >
              <a-tag v-if="item.classify_id === 1" color="#FFAD28">
                {{ item.classify_name }}
              </a-tag>
              <a-tag v-else-if="item.classify_id === 2" color="#FF455B">
                {{ item.classify_name }}
              </a-tag>
              <a-tag v-else-if="item.classify_id === 3" color="#E75934">
                {{ item.classify_name }}
              </a-tag>
              <a-tag v-else-if="item.classify_id === 4" color="#26BFBF">
                {{ item.classify_name }}
              </a-tag>
              <div class="ctrls"  v-show="loginUserId==userId">
                <a-button
                  type="link"
                  danger
                  @click="collect(item, 1)"
                  style="font-size: 15px"
                  >取消收藏</a-button
                >
              </div>
            </div>
            <div class="attrs">
              <span>{{ item.addtime }}</span>
              <span class="praise" :class="{ praised: item.isPraise }">
                <i class="iconfont icon-dianzan_kuai"></i
                >{{ numWan(item.praise_qua) }}
              </span>
              <span
                class="collection"
                :class="{ collected: item.isCollection }"
              >
                <i class="iconfont icon-shoucang"></i
                >{{ numWan(item.collect_qua) }}
              </span>
              <span class="browse">
                <i class="iconfont icon-liulan"></i
                >{{ numWan(item.browse_qua) }}
              </span>
            </div>
          </div>

          <div class="page" v-if="page.allPage && page.allPage > 1">
            <a-pagination
              v-model:current="page.currentPage"
              :total="page.allSize"
              :show-total="(total) => `共 ${page.allSize} 篇`"
              :page-size="10"
              show-quick-jumper
              @change="
                (e) => {
                  changePage(e, 1);
                }
              "
            />
          </div>
        </div>
        <div class="tab-blank" v-else>
          <a-empty />
        </div>
      </a-tab-pane>
      <a-tab-pane key="04" :tab="'论文（' + page2.allSize + '）'">
        <div class="list" v-if="list2.length > 0">
          <div class="item" v-for="item in list2" :key="item.essay_id">
            <div class="title">
              <router-link
                :to="{ path: '/essay_detail', query: { id: item.res_id } }"
                target="_blank"
                >{{ item.title }}</router-link
              >
              <div class="ctrls"  v-show="loginUserId==userId">
                <a-button
                  type="link"
                  danger
                  @click="collect(item, 2)"
                  style="font-size: 15px"
                  >取消收藏</a-button
                >
              </div>
            </div>
            <div class="attrs">
              <span>{{ item.addtime }}</span>
              <span class="praise" :class="{ praised: item.isPraise }">
                <i class="iconfont icon-dianzan_kuai"></i
                >{{ numWan(item.praise_qua) }}
              </span>
              <span
                class="collection"
                :class="{ collected: item.isCollection }"
              >
                <i class="iconfont icon-shoucang"></i
                >{{ numWan(item.collect_qua) }}
              </span>
              <span class="browse">
                <i class="iconfont icon-liulan"></i
                >{{ numWan(item.browse_qua) }}
              </span>
            </div>
          </div>

          <div class="page" v-if="page2.allPage && page2.allPage > 1">
            <a-pagination
              v-model:current="page2.currentPage"
              :total="page2.allSize"
              :show-total="(total) => `共 ${page2.allSize} 篇`"
              :page-size="10"
              show-quick-jumper
              @change="
                (e) => {
                  changePage(e, 2);
                }
              "
            />
          </div>
        </div>
        <div class="tab-blank" v-else>
          <a-empty />
        </div>
      </a-tab-pane>
      <a-tab-pane key="12" :tab="'论文集（' + page3.allSize + '）'">
        <div class="list" v-if="list3.length > 0">
          <div class="item" v-for="item in list3" :key="item.essay_id">
            <div class="title">
              <router-link
                :to="{ path: '/collection_detail', query: { id: item.res_id } }"
                target="_blank"
                >{{ item.agg_name }}</router-link
              >
              <div class="ctrls"  v-show="loginUserId==userId">
                <a-button
                  type="link"
                  danger
                  @click="collect(item, 3)"
                  style="font-size: 15px"
                  >取消收藏</a-button
                >
              </div>
            </div>
            <div class="attrs">
              <span>{{ item.addtime }}</span>
              <!-- <span class="praise" @click="praise(item)">
                <i class="iconfont icon-dianzan_kuai"></i>{{ numWan(item.praise_qua) }}
              </span>
              <span
                class="collection"
                :class="{ collected: item.isCollection }"
                @click="collect(item, 3)"
              >
                <i class="iconfont icon-shoucang"></i>{{ numWan(item.collect_qua) }}
              </span>
              <span class="browse">
                <i class="iconfont icon-liulan"></i>{{ numWan(item.browse_qua) }}
              </span> -->
              <div style="float: right">
                {{ numWan(item.collect_qua) }}人收藏
                <a-divider type="vertical" /> {{ numWan(item.artiNum) }}篇论文
              </div>
            </div>
          </div>

          <div class="page" v-if="page3.allPage && page3.allPage > 1">
            <a-pagination
              v-model:current="page3.currentPage"
              :total="page3.allSize"
              :show-total="(total) => `共 ${page3.allSize} 篇`"
              :page-size="10"
              show-quick-jumper
              @change="
                (e) => {
                  changePage(e, 3);
                }
              "
            />
          </div>
        </div>
        <div class="tab-blank" v-else>
          <a-empty />
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  ref,
  watch,
  computed,
} from "vue";
import { useRoute } from "vue-router";
import Http from "../../until/http";
import {
  confirmLogin,
  getCookie,
  getLocalItem,
  messageTips,
  numWan,
} from "../../until/tools";
export default defineComponent({
  setup() {
    let list = ref([]);
    let list2 = ref([]);
    let list3 = ref([]);
    let page = ref({ allSize: 0 });
    let page2 = ref({ allSize: 0 });
    let page3 = ref({ allSize: 0 });
    const route = useRoute();
    const userId = computed(()=>{
                return parseInt(route.query.id);
            });
    const loginUserId = computed(() => {
      // return getCookie("userId");
      // return getLocalItem("userInfo").userId;
        return getLocalItem('userInfo')?parseInt(getLocalItem('userInfo').userId):null;
    });
    const state = reactive({
      activeKey: "07",
      countData: { article: 0, essay: 0, collection: 0 },
    });
    const keywords = computed(() => {
      return route.query.keyword;
    });
    const changePage = (num, type) => {
      if (type === 1 || type === "1") {
        Http.getUserCollection({
          userId: userId.value,
          classifyCode: "07",
          currentPage: num,
          keyword: keywords.value,
        }).then((res) => {
          if (res.collectionList) {
            list.value = res.collectionList;
          }
          if (res.page) {
            page.value = res.page;
          }
        });
      } else if (type === 2 || type === "2") {
        Http.getUserCollection({
          userId: userId.value,
          classifyCode: "04",
          currentPage: num,
          keyword: keywords.value,
        }).then((res) => {
          if (res.collectionList) {
            list2.value = res.collectionList;
          }
          if (res.page) {
            page2.value = res.page;
          }
        });
      } else if (type === 3 || type === "3") {
        Http.getUserCollection({
          userId: userId.value,
          classifyCode: "12",
          currentPage: num,
          keyword: keywords.value,
        }).then((res) => {
          if (res.collectionList) {
            list3.value = res.collectionList;
          }
          if (res.page) {
            page3.value = res.page;
          }
        });
      }
    };
    let getList = (num) => {
      Http.getUserCollection({
        userId:userId.value,
        classifyCode: "07",
        currentPage: num,
        keyword: keywords.value,
      }).then((res) => {
        if (res.collectionList) {
          list.value = res.collectionList;
        }
        if (res.page) {
          page.value = res.page;
        }
      });
      Http.getUserCollection({
        userId: userId.value,
        classifyCode: "04",
        currentPage: num,
        keyword: keywords.value,
      }).then((res) => {
        if (res.collectionList) {
          list2.value = res.collectionList;
        }
        if (res.page) {
          page2.value = res.page;
        }
      });
      Http.getUserCollection({
        userId: userId.value,
        classifyCode: "12",
        currentPage: num,
        keyword: keywords.value,
      }).then((res) => {
        if (res.collectionList) {
          list3.value = res.collectionList;
        }
        if (res.page) {
          page3.value = res.page;
        }
      });
    };
    watch(keywords, () => {
      getList(1);
    });

    const collect = (item, type) => {
      let sid = getCookie("z_sid");
      if (!sid) {
        confirmLogin();
      }
      if (type === 1) {
        let params = {
          resId: item.res_id,
          resUserId: item.resUserId,
          flag: item.isCollection ? 1 : 0,
        };
        Http.articleCollect(params).then((res) => {
          if (res) {
            if (res.success) {
              
              const {allSize,currentPage,pageSize} = page.value;                  
              let allPage = Math.ceil((allSize-1)/pageSize);
              let pagex;
              if(allPage<currentPage) {
                pagex = allPage;
              } else {
                pagex = currentPage;
              }
              if(pagex<1) {
                pagex=1;
              }
              Http.getUserCollection({
                userId:userId.value,
                classifyCode: "07",
                currentPage: pagex,
                keyword: keywords.value,
              }).then((res) => {
                if (res.collectionList) {
                  list.value = res.collectionList;
                }
                if (res.page) {
                  page.value = res.page;
                }
              });
            }
          }
        });
      } else if (type === 2) {
        let params = {
          resId: item.res_id,
          flag: item.isCollection ? 1 : 0,
          resUserId: item.user_id ? item.user_id : 0,
        };
        Http.setEssayCollectStatus(params).then((res) => {
          if (res && res.success) {
            const {allSize,currentPage,pageSize} = page2.value;                  
            let allPage = Math.ceil((allSize-1)/pageSize);
            let page;
            if(allPage<currentPage) {
              page = allPage;
            } else {
              page = currentPage;
            }
            if(page<1) {
              page=1;
            }
            Http.getUserCollection({
              userId:userId.value,
              classifyCode: "04",
              currentPage: page,
              keyword: keywords.value,
            }).then((res) => {
              if (res.collectionList) {
                list2.value = res.collectionList;
              }
              if (res.page) {
                page2.value = res.page;
              }
            });
          }
        });
      } else if (type === 3) {
        Http.scCollection({
          resId: item.res_id,
          resUserId: item.user_id,
        }).then((res) => {
          if (res && res.status) {
            const {allSize,currentPage,pageSize} = page3.value;                  
            let allPage = Math.ceil((allSize-1)/pageSize);
            let page;
            if(allPage<currentPage) {
              page = allPage;
            } else {
              page = currentPage;
            }
            if(page<1) {
              page=1;
            }
            Http.getUserCollection({
              userId: userId.value,
              classifyCode: "12",
              currentPage: page,
              keyword: keywords.value,
            }).then((res) => {
              if (res.collectionList) {
                list3.value = res.collectionList;
              }
              if (res.page) {
                page3.value = res.page;
              }
            });
          } else {
            messageTips(res.message, 1);
          }
        });
      }
    };

    onMounted(() => {
      getList(1);
    });
    watch(userId, () => {
      state.activeKey.value = "07";
      list.value = [];
      list2.value = [];
      list3.value = [];
      page.value = { allSize: 0 };
      page2.value = { allSize: 0 };
      page3.value = { allSize: 0 };
      getList(1);
    });
    return {
      list,
      list2,
      list3,
      page,
      page2,
      page3,
      getList,
      changePage,
      ...toRefs(state),
      collect,
      numWan,
      userId,
      loginUserId,
    };
  },
});
</script>
